/** Stable ids for experiments that support per-feature opt-in. */
export const LABS_FEATURE = {
  sessionLayoutV2: 'session_layout_v2',
  adaptiveLearning: 'adaptive_learning',
} as const;

export type LabsFeatureId = (typeof LABS_FEATURE)[keyof typeof LABS_FEATURE];
